import React from 'react';
import { SupplyClass } from '../inputs/supplyClassesData';
import { ClassIDetails } from './details/ClassIDetails';
interface CollapsibleDetailsProps {
  supplyClass: SupplyClass;
}
export const CollapsibleDetails: React.FC<CollapsibleDetailsProps> = ({
  supplyClass
}) => {
  // Render different details based on supply class
  if (supplyClass.id === 'class-i') {
    return <ClassIDetails data-id="element-645" />;
  }
  // Default view for other classes
  return <div className="py-4 px-6 bg-gray-50 border-t border-gray-200" data-id="element-646">
      <p className="text-sm text-gray-500" data-id="element-647">
        Detailed prediction data for Class {supplyClass.romanNumeral} -{' '}
        {supplyClass.name} will be shown here.
      </p>
    </div>;
};